import { css } from 'styled-components';
import { colorCSS } from './colors';
export const tableCSS = css `
  table {
    background-color: ${colorCSS('N0')};
    color: ${colorCSS('N900')};
    display: block;
    font-size: 1rem;
    margin-bottom: 1.5rem;
    overflow-x: auto;
    width: 100%;
    th {
      background-color: ${colorCSS('N20')};
    }
    th,
    td {
      border: 1px solid ${colorCSS('N40')};
      padding: 0.33rem 0.5rem;
      vertical-align: top;
    }
  }
`;
//# sourceMappingURL=tables.js.map